/** @module SiteAdmin/Document/PushAsReferencedDocument */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/Controller",
	"csi/comm/PostRequest",
	"csi/xml"
], function(declare,lang,Controller,PostRequest,xml) {

	return declare(Controller, {
		/**
		 * @Override
		 * Check which node selections should be read-only and make sure that at least one node is selected
		 */
		onFormData: function(fd) {
			fd.m_bRequireOne = true;
			fd.m_fAggregateTest = lang.hitch(this, this._canAggregateNode);
		},

		/**
		 * Only allow selection of nodes with Write access
		 */
		_canAggregateNode: function(ctx, fd) {
			return xml.nodeHasRight(ctx.cache.getNode(ctx.getNode().DocumentsAndComments), xml.RIGHT_WRITE);
		},

		process: function() {
			// summary: issue request so as to be able to receive return value
			var req = this.m_action.m_request;
			var fd = this.m_formData;

			this.setProgress();

			new PostRequest(req.m_module, req.m_operation)
				.addParameter("URL", this.getNodeURL())
				.addParameter("AddURLs", fd.getSelectedValue())
				.post({}).then(lang.hitch(this, this._onPublishResponse));
		}
	});
});
